import { mapGetters } from 'vuex'
const moment = require('moment')
const utils = () => {
    return {
        data() {
            return {
                roomID: 0,
                roomDetails: null,
                loginUser: null,
                intervallTagenOptions: [
                    { text: "Früh nüchtern", value: "1" },
                    { text: "Früh", value: "2" },
                    { text: "Mittag", value: "3" },
                    { text: "Spät", value: "4" },
                    { text: "Nacht", value: "5" }
                ],
                artMedicineCourseOption:[
                    { text: "gegeben", value: "1", kommenter: false },
                    { text: "gegeben aber nicht angesetzt", value: "2", kommenter: false },
                    { text: "nicht gegeben", value: "3" , kommenter: true},
                    { text: "vom Arzt angesetzt", value: "4", kommenter: false },
                    { text: "vom Arzt abgesetzt", value: "5", kommenter: false },
                    { text: "gestellt", value: "6", kommenter: false }
                ],
                AtmungArray: [
                    { text: "normal", value: "0" },
                    { text: "gelegentlich angestrengtes atmen", value: "1" },
                    { text: "kurze Phasen von Hyperventilation", value: "1" },
                    { text: "lautstark anstregent atmen", value: "2" },
                    { text: "lange Phasen von Hyperventilation", value: "2" },
                    { text: "Cheyne Stoke Atmung", value: "2" }
                ],
                Negative_Lautaeuberung_Array: [
                    { text: "keine", value: "0" },
                    { text: "gelegentlich stöhnen oder ächzen", value: "1" },
                    { text: "sich leise negativ oder missbilligenden äußernk", value: "1" },
                    { text: "wiederholt beunruhigt rufen", value: "2" },
                    { text: "laut stöhnen oder ächzen", value: "2" },
                    { text: "weinen", value: "2" }
                ],
                GesichtsausdruckArray: [
                    { text: "lächelnd oder nichts sagend", value: "0" },
                    { text: "trauriger Gesichtsausdruck", value: "1" },
                    { text: "ängstlicher Gesichtsausdruck", value: "1" },
                    { text: "sorgenvoller Blick", value: "1" },
                    { text: "grimassieren", value: "2" }
                ],
                KoerperspracheArray: [
                    { text: "entspannt", value: "0" },
                    { text: "angespannnte Körperhaltung", value: "1" },
                    { text: "nervös hin und her gehen", value: "1" },
                    { text: "nesteln", value: "1" },
                    { text: "Körpersprache starr", value: "2" },
                    { text: "geballte Fäuste", value: "2" },
                    { text: "angezogene Knie", value: "2" },
                    { text: "sich entziehen oder wegstoßen", value: "2" },
                    { text: "schlagen", value: "2" }
                ],
                TrostArray: [
                    { text: "trösten nicht notwendig", value: "0" },
                    { text: "trösten möglich", value: "1" },
                    { text: "trösten nicht möglich", value: "2" }
                ],
                rateOptions: [
                    {
                      feedback: "1",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "2",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "3",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "4",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "5",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "6",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "7",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "8",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "9",
                      iconActiveClass: "blue-text",
                    },
                    {
                      feedback: "10",
                      iconActiveClass: "blue-text",
                    }
                ],
                priorityOptions: [
                  { text: "Prio 1", value: 1 },
                  { text: "Prio 2", value: 2 },
                  { text: "Prio 3", value: 3 }
                ],
                oozingOptions: [
                  { text: "keine Angabe", value: 0 },
                  { text: "wässrig", value: 1 },
                  { text: "blutend", value: 2 },
                  { text: "eitrig", value: 3 }
                ],
                woundEdgesOptions: [
                  { text: "keine Angabe", value: 0 },
                  { text: "zerkluftet", value: 1 },
                  { text: "erhaben", value: 2 },
                  { text: "gerötet", value: 3 }
                ],
                smellOptions: [
                  { text: "keine Angabe", value: 0 },
                  { text: "blutig", value: 1 },
                  { text: "unauffällig", value: 2 },
                  { text: "fäkulent", value: 3},
                  { text: "süsslich", value: 4 },
                  { text: "faulig/jauchig", value: 5 }
                ],
                optionDatePicker: {
                  week: ['M', 'D', 'M', 'D', 'F', 'S', 'S'],
                  month: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August',
                    'September', 'Oktober', 'November', 'Dezember'],
                  buttons: {
                    ok: 'OK',
                    cancel: 'Löschen',
                    clear: 'Löschen',
                    today: 'HEUTE'
                  },
                  format: 'DD-MM-YYYY'
                },
                optionTimePicker: {
                    done: 'OK',
                    cancel: 'Löschen',
                    clear: 'Löschen',
                },
                dateDefault : new Date().toJSON().slice(0,10).split('-').reverse().join('-')
            }
        },
        computed: {
            ...mapGetters('app', {
                schichtOptions: 'getSchichtOption',
                room_ID: 'getRoomID',
                room_Details: 'getRoomData'
            }),
            ...mapGetters('auth', {
                login_User: 'authenticatedUser',
            }),
        },

        created() {
            this.roomID = this.room_ID ? this.room_ID : localStorage.getItem("roomID")
            this.roomDetails = this.room_Details.length ? this.room_Details : JSON.parse(localStorage.getItem("room"))
            this.loginUser = this.login_User ? this.login_User : JSON.parse(localStorage.getItem("loginUSer"))
        },

        methods: {
            schichtValue (id) {
                let val = this.schichtOptions.find(option => {
                    return option.value == id
                })
                if (val) {
                    return val.text
                }
                return id
            },
            schichtColor (id) {
                let val = this.schichtOptions.find(option => {
                    return option.value == id
                })
                if (val) {
                    return val.color
                }
                return 'warning'
            },
            serverDateFormat (date) {
                if(date)
                    return moment(date).format('YYYY-MM-DDTHH:mm:ssZ')
            },
            getArtOptions() {
                this.$http.get('Referenzdaten/mat')
                    .then(res => {
                        if(res.data) {
                            let artArray = res.data.data
                            let list=[]
                            artArray.map(function(art) {
                                const element = { 'text': art.Text, 'value': art.Id }
                                list.push(element)
                            })
                             return list
                        }
                    })
            },
            getTextValue (array, id) {
              let val = array.find(option => {
                return option.value == id
              })
              if (val) {
                  return val.text
              }
              return id
            },
            formatDateY (date) {
              if (!date) return ''
              const [day, month, year] = date.split('-')
              return `${year}-${month}-${day}`
            },
            formatDate (date) {
              if(date)
                  return moment(date).format('DD.MM.YYYY')
            },
        },
    }
}
export default utils
